// extracted by mini-css-extract-plugin
module.exports = {"blockInfoUser":"PersonalData_blockInfoUser__3l9HQ","markName":"PersonalData_markName__2YNGw"};